export function findUrlQueryParam(name: string): string | null {
    const queryParams = new URLSearchParams(window.location.search);
    return queryParams.get(name);
}
